export default __webpack_public_path__ + "static/media/phone.fe69478c.png";